export default {
  allTasks: state => state.tasks,
  currentTask: state => state.task,
  allComments: state => state.comments,
  uiFlags: state => state.uiFlags,
};
